import { motion } from 'framer-motion';
import { useInView } from '../../home/hooks/useInView';

const services = [
  {
    icon: 'ri-lightbulb-line',
    title: '專利申請與策略',
    description: '協助您評估發明的專利價值，規劃申請策略，並處理從申請到核准的完整流程，確保您的技術創新獲得完整保護。',
    color: 'from-[#2c5282] to-[#1a365d]',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '商標申請與保護',
    description: '從商標檢索、申請註冊到維權管理，協助您建立獨特的品牌識別，避免侵權風險，保護您的品牌價值。',
    color: 'from-[#2d3748] to-[#1a202c]',
  },
  {
    icon: 'ri-file-text-line',
    title: '著作權諮詢',
    description: '提供著作權登記、授權合約審查與侵權處理建議，保障您的創作成果不被非法使用或抄襲。',
    color: 'from-[#2c5282] to-[#1a365d]',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '智慧財產權布局與管理',
    description: '為企業量身打造智產權組合策略，從研發初期就開始規劃，建立完整的智產權防護網，提升競爭優勢。',
    color: 'from-[#2d3748] to-[#1a202c]',
  },
  {
    icon: 'ri-user-star-line',
    title: 'IP 顧問與策略諮詢',
    description: '提供長期智產權顧問服務，協助企業建立智產權管理制度，並在商業決策中融入智產權思維，創造更大價值。',
    color: 'from-[#2c5282] to-[#1a365d]',
  },
];

export function Services() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="inline-block px-4 py-2 bg-[#2c5282]/10 rounded-full text-sm font-semibold text-[#2c5282] mb-4"
          >
            專業服務
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold text-[#1a365d] mb-6"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            我們能協助的服務
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg text-gray-600 max-w-3xl mx-auto"
          >
            從專利、商標到著作權，提供全方位的智慧財產權保護與管理服務
          </motion.p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              whileHover={{ y: -8, scale: 1.02 }}
              className="group relative bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#2c5282] hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a365d] mb-4" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}